import React, { Fragment } from 'react';
import { Banner } from '@spotify-internal/encore-creator-web';
import tokens from '@spotify-internal/encore-foundation';

export const ErrorPage = () => (
  <Fragment>
    <div style={{ marginTop: tokens.spacer32 }} />
    <Banner variant={Banner.warning} data-qa="error-page">
      Sorry, you do not have permission to access this page.
    </Banner>
  </Fragment>
);

ErrorPage.displayName = 'ErrorPage';
